
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { css } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var textContainer = function textContainer(_ref, weight, size) {
  var typeScaleSizes = _ref.typeScaleSizes;
  return /*#__PURE__*/ /*#__PURE__*/css("font-size:", typeScaleSizes[size], ";font-weight:", weight, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textContainer;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRMEIiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBUaGVtZSwgU2VyaWFsaXplZFN0eWxlcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuaW1wb3J0IHsgVGV4dFdlaWdodCB9IGZyb20gXCIuL1RleHRcIjtcbmltcG9ydCB7IFR5cG9ncmFwaHlMZXZlbHMgfSBmcm9tIFwiQHRoZW1lL3V0aWxzL3R5cG9ncmFwaHlcIjtcblxuZXhwb3J0IGNvbnN0IHRleHRDb250YWluZXIgPSAoXG4gIHsgdHlwZVNjYWxlU2l6ZXMgfTogVGhlbWUsXG4gIHdlaWdodDogVGV4dFdlaWdodCxcbiAgc2l6ZTogVHlwb2dyYXBoeUxldmVscyxcbik6IFNlcmlhbGl6ZWRTdHlsZXMgPT4gY3NzYFxuICBmb250LXNpemU6ICR7dHlwZVNjYWxlU2l6ZXNbc2l6ZV19O1xuICBmb250LXdlaWdodDogJHt3ZWlnaHR9O1xuYDtcbiJdfQ== */", process.env.NODE_ENV === "production" ? "" : ";label:textContainer;");
};

export { textContainer };
//# sourceMappingURL=styles.js.map
